var map = {
	"./Dr. C Jegadheesan.jpeg": 56283,
	"./Dr. K S Karthi Vinith.jpeg": 21870,
	"./Dr. M Boopathi.jpeg": 96948,
	"./Dr. N. Baaskaran.jpg": 11876,
	"./Dr. P C Murugan.jpg": 35478,
	"./Dr. R Parameshwaran.png": 29902,
	"./Mr. G Manikandan.jpg": 78922,
	"./Mr. K Nithyanandhan.jpg": 75487,
	"./Mr. T Karthi.jpg": 25230,
	"./Mr.P.Senthil kumar.JPG": 43161,
	"./gowtham.png": 1899,
	"./mahendiran.jpg": 34587,
	"./sudhirkumar.jpg": 91155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75544;